import { render, staticRenderFns } from "./placingSuccessfullyPage.vue?vue&type=template&id=90280404&scoped=true&"
import script from "./placingSuccessfullyPage.vue?vue&type=script&lang=js&"
export * from "./placingSuccessfullyPage.vue?vue&type=script&lang=js&"
import style0 from "./placingSuccessfullyPage.vue?vue&type=style&index=0&id=90280404&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90280404",
  null
  
)

export default component.exports